import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import AssetImage from "src/components/wizard/Item/AssetImage";

const styles = {
  listItem: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    maxWidth: "100%",
  },
};

export default function SearchResultItem({ result, onClick }) {
  switch (result.__typename) {
    case "Project":
      return (
        <ListItemButton key={`project-${result.id}`} onClick={() => onClick(result)}>
          <Box display="flex" alignItems="center" width="100%">
            <Box mr={2}>
              <AssetImage image={result.customerLogoUrl} width={50} height={50} />
            </Box>
            <ListItemText
              primary={result.name}
              primaryTypographyProps={{ style: styles.listItem }}
            />
          </Box>
        </ListItemButton>
      );
    case "Asset":
      return (
        <ListItemButton key={`asset-${result.id}`} onClick={() => onClick(result)}>
          <Box display="flex" alignItems="center" width="100%">
            <Box mr={2}>
              <AssetImage image={result.images?.[0]?.url} width={50} height={50} />
            </Box>
            <ListItemText
              primary={[result.itemId, result.description].filter(Boolean).join(", ")}
              primaryTypographyProps={{ style: styles.listItem }}
            />
          </Box>
        </ListItemButton>
      );
    case "Shipment":
      return (
        <ListItemButton key={`shipment-${result.id}`} onClick={() => onClick(result)}>
          <Box display="flex" alignItems="center" width="100%">
            <Box mr={2}>
              <AssetImage image={result.attachments?.[0]?.url} width={50} height={50} />
            </Box>
            <ListItemText
              primary={[result.shipmentId, result.project?.name].filter(Boolean).join(", ")}
              primaryTypographyProps={{ style: styles.listItem }}
            />
          </Box>
        </ListItemButton>
      );
    default:
      return null;
  }
}
